import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submitFinance, resetStatus } from '../redux/slices/financeSlice';
import { fetchMonthlyFinance } from '../redux/slices/financeSlice';
import dayjs from 'dayjs';
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    Select,
    VStack,
    HStack,
    Text,
    NumberInput,
    NumberInputField,
    Heading,
    Card,
    CardBody,
    SimpleGrid,
    Container
} from '@chakra-ui/react';
import { resetState } from '../redux/actions/userActions';
import React from 'react';
import axios from 'axios';
const FinanceForm = () => {
    const dispatch = useDispatch();
    const [year, setYear] = useState('2025');
    const [month, setMonth] = useState('11');
    const { loading, error, success, summary } = useSelector((state) => state.financeSlice);
    console.log(summary)
    // console.log({ loading, error, success }, "teszt");

    const [formData, setFormData] = useState({
        type: 'income',
        date: dayjs().format('YYYY-MM-DD'),
        supplier: '',
        category: '',
        _0: 0,
        _5: 0,
        _18: 0,
        _27: 0,
        totalAmount: 0,
    });

    // totalAmount automatikus számítása
    useEffect(() => {
        const total =
            Number(formData._0) + Number(formData._5) + Number(formData._18) + Number(formData._27);
        setFormData((prev) => ({ ...prev, totalAmount: total }));
    }, [formData._0, formData._5, formData._18, formData._27]);

    // input handler
    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    // submit handler
    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.type === 'expense') {
            if (!formData.supplier.trim() || !formData.category.trim()) {
                alert('Szállító és kategória kitöltése kötelező!');
                return;
            }
        }

        dispatch(
            submitFinance({
                type: formData.type,
                date: formData.date,
                supplier: formData.supplier,
                category: formData.category,
                amounts: {
                    _0: Number(formData._0),
                    _5: Number(formData._5),
                    _18: Number(formData._18),
                    _27: Number(formData._27),
                },
                totalAmount:
                    Number(formData._0) + Number(formData._5) + Number(formData._18) + Number(formData._27),
            })

        );
        dispatch(fetchMonthlyFinance({ year, month }));
    };

    const handleDeleteInvoice = async (id) => {
        try {
            await axios.delete(`/api/invoices/${id}`);
            if (year && month) dispatch(fetchMonthlyFinance({ year, month }));
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteSale = async (id) => {
        try {
            await axios.delete(`/api/sales/${id}`);
            dispatch(fetchMonthlyFinance({ year, month })); // frissíti a listát
        } catch (error) {
            console.error(error);
        }
    };

        const handleDeleteExpense = async (id) => {
        try {
            await axios.delete(`/api/expenses/${id}`);
            dispatch(fetchMonthlyFinance({ year, month })); // frissíti a listát
        } catch (error) {
            console.error(error);
        }
    };


    useEffect(() => {
        if (success || error) {
            const timeout = setTimeout(() => dispatch(resetState()), 3000);
            return () => clearTimeout(timeout);
        }
    }, [success, error, dispatch]);

    useEffect(() => {
        if (year && month) {
            dispatch(fetchMonthlyFinance({ year, month }));
        }
    }, [year, month, dispatch]);


    return (
        <Box my={10}>
            <Heading textAlign="center" fontSize="2xl" fontWeight="extrabold">
                Admin Számla hozzáadás
            </Heading>
            <Box maxW="md" mx="auto" mt={10} p="6" shadow="md" borderRadius="md" bg="white">

                <form onSubmit={handleSubmit}>
                    <VStack spacing={4} align="stretch">
                        <FormControl>
                            <FormLabel>Típus</FormLabel>
                            <Select
                                value={formData.type}
                                onChange={(e) => handleChange('type', e.target.value)}
                            >
                                <option value="income">Napi Forgalmi Jelentés</option>
                                <option value="expense">Számlák</option>
                                <option value="expenses">Egyéb kiadások</option>
                            </Select>
                        </FormControl>

                        <FormControl>
                            <FormLabel>Dátum</FormLabel>
                            <Input
                                type="date"
                                value={formData.date}
                                onChange={(e) => handleChange('date', e.target.value)}
                            />
                        </FormControl>

                        {formData.type === 'expense' && (
                            <>
                                <FormControl>
                                    <FormLabel>Szállító</FormLabel>
                                    <Input
                                        value={formData.supplier}
                                        onChange={(e) => handleChange('supplier', e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Kategória</FormLabel>
                                    <Input
                                        value={formData.category}
                                        onChange={(e) => handleChange('category', e.target.value)}
                                    />
                                </FormControl>
                            </>
                        )}

                        {formData.type === 'expenses' && (
                            <>
                               
                                <FormControl>
                                    <FormLabel>Kategória</FormLabel>
                                    <Input
                                        value={formData.category}
                                        onChange={(e) => handleChange('category', e.target.value)}
                                    />
                                </FormControl>
                            </>
                        )}

                        <HStack spacing={2}>
                            <FormControl>
                                <FormLabel>ÁFA0(DRS)</FormLabel>
                                <NumberInput
                                    value={formData._0}
                                    onChange={(valueString) => handleChange('_0', valueString)}
                                >
                                    <NumberInputField />
                                </NumberInput>
                            </FormControl>
                            <FormControl>
                                <FormLabel>ÁFA 5%</FormLabel>
                                <NumberInput
                                    value={formData._5}
                                    onChange={(valueString) => handleChange('_5', valueString)}
                                >
                                    <NumberInputField />
                                </NumberInput>
                            </FormControl>

                            <FormControl>
                                <FormLabel>ÁFA 18%</FormLabel>
                                <NumberInput
                                    value={formData._18}
                                    onChange={(valueString) => handleChange('_18', valueString)}
                                >
                                    <NumberInputField />
                                </NumberInput>
                            </FormControl>

                            <FormControl>
                                <FormLabel>ÁFA 27%</FormLabel>
                                <NumberInput
                                    value={formData._27}
                                    onChange={(valueString) => handleChange('_27', valueString)}
                                >
                                    <NumberInputField />
                                </NumberInput>
                            </FormControl>
                        </HStack>

                        <FormControl>
                            <FormLabel>Összesen (bruttó) Ft</FormLabel>
                            <Input value={formData.totalAmount.toLocaleString('hu-HU')} isReadOnly />
                        </FormControl>

                        <Button type="submit" colorScheme="green" isLoading={loading}>
                            Mentés
                        </Button>

                        {error && <Text color="red.500">{error}</Text>}
                        {success && <Text color="green.500">Sikeresen mentve!</Text>}
                    </VStack>
                </form>
            </Box>

            {/* ELADÁSOK TÁBLÁZAT */}
            <Container maxW='container.xl'>
                <Card mt={4}>
                    <CardBody>
                        <Text fontWeight="bold" mb={2}>🛒 Utolsó 5 Napi Forgalmi Jelentés:</Text>

                        <SimpleGrid columns={4} spacing={3} fontSize="sm" textAlign="center">
                            {/* Fejléc */}
                            <Text fontWeight="bold">Dátum</Text>
                            <Text fontWeight="bold">Végösszeg</Text>
                            <Text fontWeight="bold">Megjegyzés</Text>
                            <Text fontWeight="bold">Művelet</Text>

                            {/* Adatok */}
                            {summary?.sales?.slice(-5).reverse().map((sale) => (
                                <React.Fragment key={sale._id}>
                                    <Text>{new Date(sale.date).toLocaleDateString()}</Text>
                                    <Text>{sale.totalAmount.toLocaleString('hu-HU')} Ft</Text>
                                    <Text>{sale.note || '-'}</Text>
                                    <Button
                                        size="sm"
                                        colorScheme="red"
                                        onClick={() => handleDeleteSale(sale._id)}
                                    >
                                        Törlés
                                    </Button>
                                </React.Fragment>
                            ))}

                        </SimpleGrid>
                    </CardBody>
                </Card>
            </Container>
            <Container maxW='container.xl'>
                <Card mt={4}>
                    <CardBody>
                        <Text fontWeight="bold" mb={2}>🛒 Utolsó 5 Számla:</Text>

                        <SimpleGrid columns={5} spacing={3} fontSize="sm" textAlign="center">
                            {/* Fejléc */}
                            <Text fontWeight="bold">Dátum</Text>
                            <Text fontWeight="bold">Összeg</Text>
                            <Text fontWeight="bold">Szállító</Text>
                            <Text fontWeight="bold">Kategória</Text>
                            <Text fontWeight="bold">művelet</Text>

                            {/* Adatok */}
                            {summary?.invoices?.slice(-5).reverse().map((sale) => (
                                <React.Fragment key={sale._id}>
                                    <Text>{new Date(sale.date).toLocaleDateString()}</Text>
                                    <Text>{sale.totalAmount.toLocaleString('hu-HU')} Ft</Text>
                                    <Text>{sale.supplier || '-'}</Text>
                                    <Text>{sale.category || '-'}</Text>
                                    <Button
                                        size="sm"
                                        colorScheme="red"
                                        onClick={() => handleDeleteInvoice(sale._id)}
                                    >
                                        Törlés
                                    </Button>
                                </React.Fragment>
                            ))}
                        </SimpleGrid>
                    </CardBody>
                </Card>
            </Container>


             {/* Egyéb Kiadás*/}
             <Container maxW='container.xl'>
                <Card mt={4}>
                    <CardBody>
                        <Text fontWeight="bold" mb={2}>🛒 Utolsó 5 Egyéb kiadás:</Text>

                        <SimpleGrid columns={5} spacing={3} fontSize="sm" textAlign="center">
                            {/* Fejléc */}
                            <Text fontWeight="bold">Dátum</Text>
                            <Text fontWeight="bold">Összeg</Text>
                            <Text fontWeight="bold">Szállító</Text>
                            <Text fontWeight="bold">Kategória</Text>
                            <Text fontWeight="bold">művelet</Text>

                            {/* Adatok */}
                            {summary?.expenses?.slice(-5).reverse().map((sale) => (
                                <React.Fragment key={sale._id}>
                                    <Text>{new Date(sale.date).toLocaleDateString()}</Text>
                                    <Text>{sale.totalAmount.toLocaleString('hu-HU')} Ft</Text>
                                    <Text>{sale.supplier || '-'}</Text>
                                    <Text>{sale.category || '-'}</Text>
                                    <Button
                                        size="sm"
                                        colorScheme="red"
                                        onClick={() => handleDeleteExpense(sale._id)}
                                    >
                                        Törlés
                                    </Button>
                                </React.Fragment>
                            ))}
                        </SimpleGrid>
                    </CardBody>
                </Card>
            </Container>
        </Box>
    );
};

export default FinanceForm;
